import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { lighten, useTheme } from '@mui/material/styles'
import { FormSectionProps } from '../../interfaces/form'
import { useForm, useFormState } from 'react-final-form'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

import FormWizard from '../wizard'
import FormRadio from '../../components/FormRadio'
import FormField from '../../components/FormField'
// import theme from '../../theme'

const radioStyle = {
  paddingBottom: 0,
  display: 'none',
}

const radioOverrideMuiStyle = {
  '&.MuiRadio-root': {
    '&.Mui-checked + span': {
      backgroundColor: `primary.main`,
      color: '#FFF !important',
    },
  },
}

const textStyle = {
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 4,
  display: 'inline-flex',
  marginTop: 0,
  marginRight: 6,
  marginBottom: 10,
  fontWeight: 'bold',
  verticalAlign: 'top',
  width: '100%',
  height: '100%',
  minHeight: 80,
  cursor: 'pointer',
}

const Smoker = ({ validate }: FormSectionProps) => {
  const form = useForm()
  const { values } = useFormState()
  const theme = useTheme()
  //@ts-ignore
  const custom = theme?.custom

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        <FormWizard.Page validate={validate}>
          <Typography variant="h3" sx={{ mb: 2 }}>
            Has your partner smoked in the last year?
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Please select ‘yes’ even if it‘s just occasionally. That includes
            e-cigarettes and other nicotine-based products.
          </Typography>
          <Grid container spacing={2} sx={{ mb: 14 }}>
            <Grid item xs={12} md={6}>
              <label
                htmlFor="partnerSmoker-yes"
                style={{ textAlign: 'center' }}
              >
                <FormRadio
                  id="partnerSmoker-yes"
                  name="isPartnerSmoker"
                  value={'true'}
                  style={radioStyle}
                  overrideMuiStyle={{
                    '&.MuiRadio-root': {
                      '&.Mui-checked + span': {
                        backgroundColor: `${theme.palette.primary.main} !important`,
                        color: '#FFF !important',
                      },
                    },
                  }}
                  onClick={async () => {
                    form.change('isPartnerSmoker', 'true')
                  }}
                />
                <Typography
                  component="span"
                  style={{
                    ...textStyle,
                    border: `1px solid ${theme.palette.primary.main}`,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Yes
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label htmlFor="partnerSmoker-no" style={{ textAlign: 'center' }}>
                <FormRadio
                  id="partnerSmoker-no"
                  name="isPartnerSmoker"
                  value="false"
                  style={radioStyle}
                  overrideMuiStyle={{
                    '&.MuiRadio-root': {
                      '&.Mui-checked + span': {
                        backgroundColor: `${theme.palette.primary.main} !important`,
                        color: '#FFF !important',
                      },
                    },
                  }}
                  onClick={async () => {
                    form.change('isPartnerSmoker', 'false')
                  }}
                />
                <Typography
                  component="span"
                  style={{
                    ...textStyle,
                    border: `1px solid ${theme.palette.primary.main}`,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  No
                </Typography>
              </label>
            </Grid>
          </Grid>

          { custom.apiKey === "2d6fe9fa-ead6-4bb4-b285-90967190067a" ? <>
            { values["isPartnerSmoker"] === "false" ? <>
              <Typography variant="body1" sx={{ mb: 2 }}>
              If no, Have you smoked in the last 5 years?
              </Typography>
              <Grid container spacing={2} sx={{ mb: 14 }}>
                <Grid item xs={12} md={6}>
                  <label
                    htmlFor="partnerSmokedLast5Years-yes"
                    style={{ textAlign: 'center' }}
                  >
                    <FormRadio
                      id="partnerSmokedLast5Years-yes"
                      name="partnerSmokedLast5Years"
                      value={'true'}
                      style={radioStyle}
                      overrideMuiStyle={{
                        '&.MuiRadio-root': {
                          '&.Mui-checked + span': {
                            backgroundColor: `${theme.palette.primary.main} !important`,
                            color: '#FFF !important',
                          },
                        },
                      }}
                      onClick={async () => {
                        form.change('partnerSmokedLast5Years', 'true')
                      }}
                    />
                    <Typography
                      component="span"
                      style={{
                        ...textStyle,
                        border: `1px solid ${theme.palette.primary.main}`,
                        backgroundColor: lighten(theme.palette.primary.main, 0.8),
                      }}
                    >
                      Yes
                    </Typography>
                  </label>
                </Grid>
                <Grid item xs={12} md={6}>
                  <label htmlFor="partnerSmokedLast5Years-no" style={{ textAlign: 'center' }}>
                    <FormRadio
                      id="partnerSmokedLast5Years-no"
                      name="partnerSmokedLast5Years"
                      value="false"
                      style={radioStyle}
                      overrideMuiStyle={{
                        '&.MuiRadio-root': {
                          '&.Mui-checked + span': {
                            backgroundColor: `${theme.palette.primary.main} !important`,
                            color: '#FFF !important',
                          },
                        },
                      }}
                      onClick={async () => {
                        form.change('partnerSmokedLast5Years', 'false')
                      }}
                    />
                    <Typography
                      component="span"
                      style={{
                        ...textStyle,
                        border: `1px solid ${theme.palette.primary.main}`,
                        backgroundColor: lighten(theme.palette.primary.main, 0.8),
                      }}
                    >
                      No
                    </Typography>
                  </label>
                </Grid>
              </Grid>
            </> : null }

            { values["isPartnerSmoker"] === "false" && values["partnerSmokedLast5Years"] === "true" ? <>
              <Typography variant="body1" sx={{ mb: 2 }}>
              If yes, when did you stop smoking?
              </Typography>
              <FormField
                id="partnerWhenDidYouStopSmoking"
                name="partnerWhenDidYouStopSmoking"
                placeholder=""
                type="text"
              />
            </> : null }

            <br/><br/><br/>
          </> : null }

          <Typography variant="body1" fontSize={16} sx={{ mb: 8 }}>
            Smokers have a higher chance of claiming on their insurance – which
            is why all insurers make this question mandatory. It’s really
            important to be honest, as we don’t want you to be in a situation
            where the insurer is refusing to pay your claim.
          </Typography>
        </FormWizard.Page>
      </Box>
    </Container>
  )
}

export default Smoker
